<template>
  <div class="touch-full-sceen" ref="touchFullScreen">
    <img :src="img" />
  </div>
</template>

<script>
import {
  toggleFullScreen,
  isFullscreen,
  setFullScreenStatus,
  getScreenfull,
} from "@/utils";
import store from "@/store/index";
import ifmTool from "@/utils/ifmTool";
const imgFull = require("@/assets/img/full-screen/UI_suofang_icon_01.png");
const imgExitFull = require("@/assets/img/full-screen/UI_suofang_icon_02.png");
export default {
  name: "touchFullSceen",
  data() {
    return {
      draggie: null,
      img: isFullscreen() ? imgExitFull : imgFull,
    };
  },
  computed: {
    screenDirection() {
      return store.state.app.screenDirection;
    },
  },
  watch: {
    screenDirection() {
      if (this.draggie && this.$refs.touchFullScreen) {
        this.$refs.touchFullScreen.removeAttribute("style");
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.draggie = new window.Draggabilly(".touch-full-sceen", {
        containment: "#body",
      });
      getScreenfull().on("change", () => {
        this.fullScreenChange();
      });
      this.draggie.on("staticClick", () => {
        toggleFullScreen();
        this.fullScreenChange();
      });
    });
  },
  methods: {
    fullScreenChange() {
      if (isFullscreen()) {
        this.img = imgExitFull;
        setFullScreenStatus(1);
        ifmTool.postFullSceenInfo(1);
      } else {
        this.img = imgFull;
        setFullScreenStatus(0);
        ifmTool.postFullSceenInfo(0);
      }
    },
    remove() {
      this.$el.parentNode && this.$el.parentNode.removeChild(this.$el);
      this.$destroy(true);
    },
  },
};
</script>

<style lang="scss" scoped>
.touch-full-sceen {
  position: fixed;
  z-index: 10;
  width: 0.4rem;
  height: 0.4rem;
  right: 1.65rem;
  top: 0.06rem;
  touch-action: none;
  img {
    width: 100%;
    height: 100%;
    display: block;
  }
}
@media all and (orientation: portrait) {
  .touch-full-sceen {
    transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    right: 0.06rem;
    bottom: 1.65rem;
    top: initial;
  }
}
</style>